import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { apiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';

const extractErrorMessage = (data) => {
  if (!data) {
    return 'Failed to register business profile';
  }
  if (data.message) {
    return data.message;
  }
  if (data.error) {
    return data.error;
  }
  return 'Failed to register business profile';
};

const registerBusinessProfile = async (profileId) => {
  const { data } = await apiClient.post(`/business-profiles/${profileId}/register`);
  return data;
};

export const useRegisterBusinessProfileHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: registerBusinessProfile,
    onSuccess: (data, profileId) => {
      dispatch(showSnackbar({ message: 'Business profile registered successfully.', variant: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['business_profiles'] });
      queryClient.invalidateQueries({ queryKey: ['business_profiles', profileId] });
      onSuccess?.(data);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: extractErrorMessage(error.response?.data),
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  return {
    registerBusinessProfile: mutation.mutate,
    isPending: mutation.isPending,
  };
};
